import { DocumentIcon } from "@heroicons/react/20/solid"
import { PrimaryFeatureFrame } from "../PrimaryFeatureFrame"

export function Upload() {
    return (
        <PrimaryFeatureFrame>
            <div className="p-10">
                <span className="block font-semibold leading-6 text-gray-900">Name</span>
                <div className="mt-2">
                    <div className="flex rounded-md shadow-sm ring-1 ring-inset ring-gray-300 focus-within:ring-2 focus-within:ring-inset focus-within:ring-primary-600 sm:max-w-md">
                        <div className="block flex-1 border-0 bg-transparent py-1.5 pl-1 text-gray-900 placeholder:text-gray-400 focus:ring-0 sm:text-sm sm:leading-6">
                            Product market fit report - March 2023
                        </div>
                    </div>
                </div>
                <span className="mt-6 block font-semibold leading-6 text-gray-900">Data file</span>
                <div className="mt-2 flex h-80 w-full flex-col justify-center rounded-lg border-2 border-dashed border-gray-900/25">
                    <div className="text-center text-primary-600">
                        <DocumentIcon className="mx-auto h-8 w-8 text-gray-300" aria-hidden="true" />
                        <span className="text-xs text-gray-700">Upload a file</span>
                    </div>
                </div>
            </div>
        </PrimaryFeatureFrame>
    )
}
